import ActiveOrderDetail from "../../pages/ActiveOrderDetail";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const OrderHistoryList = (value) => {
  const nav = useNavigate();

  const handleClick = () => {
    localStorage.setItem("item", JSON.stringify(value));
    nav("/order-history-detail", {
      state: {
        item: value,
      },
    });
  };

  return (
    <div onClick={handleClick}>
      <div className="a-order-list" onClick={handleClick}
      style={{
        whiteSpace: 'normal',
        height: 'auto'
      }}>
      <div className="a-name-img">
        <div className="a-img-container">
          <img style={{
            width: '100%',
            borderRadius: '50%'
          }} src="zmall-logo.png" alt="logo" />
        </div>
        <div className="a-name-description" style={{
          whiteSpace: 'normal',
          height: 'auto'
        }}>
        <p style={{
          color: value.value.order_status == 101 && 'var(--primary-color)',
          paddingBottom: '2px',
          wordWrap: 'break-word',
        }}>{value.value.store_detail.name}</p>
          <p>Order No. #{value.value.unique_id}</p>
          <p>{value.value.created_at}</p>
          <p style={{
            color:'var(--primary-color)'
          }}>{value.value.order_status == 25 && 'Order completed'}</p>
          <p style={{
            color:'var(--primary-color)'
          }}>{value.value.order_status == 101 && 'Cancelled by user'}</p>
        </div>
      </div>
      <div className="a-price">
        <p>{value.value.currency} {value.value.total_order_price}</p>
      </div>
    </div>
    </div>
  );
};

export default OrderHistoryList;
